import { render } from "./StatisticsRoutesAndAttractions.vue?vue&type=template&id=4b1e1a74&scoped=true"
import script from "./StatisticsRoutesAndAttractions.vue?vue&type=script&lang=js"
export * from "./StatisticsRoutesAndAttractions.vue?vue&type=script&lang=js"

import "./StatisticsRoutesAndAttractions.vue?vue&type=style&index=0&id=4b1e1a74&lang=scss&scoped=true"

import exportComponent from "/home/administrator/tourstat-front/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-4b1e1a74"]])

export default __exports__